/* ============================================================================
   POLICES — catalogo de tipografias disponibles
   ----------------------------------------------------------------------------
   ~60 Google Fonts repartidas en 6 generos: sans, serif, script, display,
   retro y mono. El cliente filtra por genero y busca por nombre.

   NUNCA se cargan todas de golpe: serian varios MB y decenas de segundos en
   movil. Cada familia se carga bajo demanda (ver chargerPolice) cuando su
   ficha entra en pantalla (IntersectionObserver) o cuando se selecciona. El
   <link> de Google se inyecta una sola vez por familia.

   Sobre los pesos: pedimos siempre wght@400;700. Verificado contra la API de
   Google que las familias de un solo peso (Pacifico, Bebas Neue, Lobster...)
   responden 200 e ignoran el 700 sin error; no hay que marcarlas aparte.

   Los ids son CONTRATO: config-personnalisation.json guarda las polices
   permitidas por producto como lista de ids. No renombrar un id existente sin
   migrar el JSON.
   ========================================================================== */

const POLICES = [
  // --- Sans serif ----------------------------------------------------------
  { id: 'hanken',       nom: 'Hanken Grotesk',    famille: 'Hanken Grotesk',      genre: 'sans'    },
  { id: 'montserrat',   nom: 'Montserrat',        famille: 'Montserrat',          genre: 'sans'    },
  { id: 'raleway',      nom: 'Raleway',           famille: 'Raleway',             genre: 'sans'    },
  { id: 'poppins',      nom: 'Poppins',           famille: 'Poppins',             genre: 'sans'    },
  { id: 'inter',        nom: 'Inter',             famille: 'Inter',               genre: 'sans'    },
  { id: 'nunito',       nom: 'Nunito',            famille: 'Nunito',              genre: 'sans'    },
  { id: 'quicksand',    nom: 'Quicksand',         famille: 'Quicksand',           genre: 'sans'    },
  { id: 'josefin',      nom: 'Josefin Sans',      famille: 'Josefin Sans',        genre: 'sans'    },
  { id: 'worksans',     nom: 'Work Sans',         famille: 'Work Sans',           genre: 'sans'    },
  { id: 'dmsans',       nom: 'DM Sans',           famille: 'DM Sans',             genre: 'sans'    },
  { id: 'outfit',       nom: 'Outfit',            famille: 'Outfit',              genre: 'sans'    },
  { id: 'lato',         nom: 'Lato',              famille: 'Lato',                genre: 'sans'    },

  // --- Serif ---------------------------------------------------------------
  { id: 'bodoni',       nom: 'Bodoni Moda',       famille: 'Bodoni Moda',         genre: 'serif'   },
  { id: 'playfair',     nom: 'Playfair Display',  famille: 'Playfair Display',    genre: 'serif'   },
  { id: 'cormorant',    nom: 'Cormorant',         famille: 'Cormorant Garamond',  genre: 'serif'   },
  { id: 'ebgaramond',   nom: 'EB Garamond',       famille: 'EB Garamond',         genre: 'serif'   },
  { id: 'libre',        nom: 'Libre Baskerville', famille: 'Libre Baskerville',   genre: 'serif'   },
  { id: 'merriweather', nom: 'Merriweather',      famille: 'Merriweather',        genre: 'serif'   },
  { id: 'dmserif',      nom: 'DM Serif',          famille: 'DM Serif Display',    genre: 'serif'   },
  { id: 'cinzel',       nom: 'Cinzel',            famille: 'Cinzel',              genre: 'serif'   },
  { id: 'lora',         nom: 'Lora',              famille: 'Lora',                genre: 'serif'   },
  { id: 'crimson',      nom: 'Crimson Text',      famille: 'Crimson Text',        genre: 'serif'   },
  { id: 'spectral',     nom: 'Spectral',          famille: 'Spectral',            genre: 'serif'   },

  // --- Script / manuscrites -------------------------------------------------
  { id: 'dancing',      nom: 'Dancing Script',    famille: 'Dancing Script',      genre: 'script'  },
  { id: 'pacifico',     nom: 'Pacifico',          famille: 'Pacifico',            genre: 'script'  },
  { id: 'yellowtail',   nom: 'Yellowtail',        famille: 'Yellowtail',          genre: 'script'  },
  { id: 'kaushan',      nom: 'Kaushan Script',    famille: 'Kaushan Script',      genre: 'script'  },
  { id: 'satisfy',      nom: 'Satisfy',           famille: 'Satisfy',             genre: 'script'  },
  { id: 'greatvibes',   nom: 'Great Vibes',       famille: 'Great Vibes',         genre: 'script'  },
  { id: 'sacramento',   nom: 'Sacramento',        famille: 'Sacramento',          genre: 'script'  },
  { id: 'caveat',       nom: 'Caveat',            famille: 'Caveat',              genre: 'script'  },
  { id: 'caveatbrush',  nom: 'Caveat Brush',      famille: 'Caveat Brush',        genre: 'script'  },
  { id: 'grandhotel',   nom: 'Grand Hotel',       famille: 'Grand Hotel',         genre: 'script'  },
  { id: 'allura',       nom: 'Allura',            famille: 'Allura',              genre: 'script'  },
  { id: 'parisienne',   nom: 'Parisienne',        famille: 'Parisienne',          genre: 'script'  },
  { id: 'marck',        nom: 'Marck Script',      famille: 'Marck Script',        genre: 'script'  },

  // --- Display / impact -----------------------------------------------------
  { id: 'bebas',        nom: 'Bebas Neue',        famille: 'Bebas Neue',          genre: 'display' },
  { id: 'anton',        nom: 'Anton',             famille: 'Anton',               genre: 'display' },
  { id: 'oswald',       nom: 'Oswald',            famille: 'Oswald',              genre: 'display' },
  { id: 'archivoblack', nom: 'Archivo Black',     famille: 'Archivo Black',       genre: 'display' },
  { id: 'lobster',      nom: 'Lobster',           famille: 'Lobster',             genre: 'display' },
  { id: 'righteous',    nom: 'Righteous',         famille: 'Righteous',           genre: 'display' },
  { id: 'abril',        nom: 'Abril Fatface',     famille: 'Abril Fatface',       genre: 'display' },
  { id: 'alfaslab',     nom: 'Alfa Slab One',     famille: 'Alfa Slab One',       genre: 'display' },
  { id: 'bangers',      nom: 'Bangers',           famille: 'Bangers',             genre: 'display' },
  { id: 'luckiest',     nom: 'Luckiest Guy',      famille: 'Luckiest Guy',        genre: 'display' },
  { id: 'marker',       nom: 'Permanent Marker',  famille: 'Permanent Marker',    genre: 'display' },
  { id: 'amatic',       nom: 'Amatic SC',         famille: 'Amatic SC',           genre: 'display' },
  { id: 'fredoka',      nom: 'Fredoka',           famille: 'Fredoka',             genre: 'display' },

  // --- Retro ---------------------------------------------------------------
  { id: 'specialelite', nom: 'Special Elite',     famille: 'Special Elite',       genre: 'retro'   },
  { id: 'monoton',      nom: 'Monoton',           famille: 'Monoton',             genre: 'retro'   },
  { id: 'rye',          nom: 'Rye',               famille: 'Rye',                 genre: 'retro'   },
  { id: 'shrikhand',    nom: 'Shrikhand',         famille: 'Shrikhand',           genre: 'retro'   },
  { id: 'ultra',        nom: 'Ultra',             famille: 'Ultra',               genre: 'retro'   },
  { id: 'poiret',       nom: 'Poiret One',        famille: 'Poiret One',          genre: 'retro'   },
  { id: 'limelight',    nom: 'Limelight',         famille: 'Limelight',           genre: 'retro'   },

  // --- Monospace ------------------------------------------------------------
  { id: 'courierprime', nom: 'Courier Prime',     famille: 'Courier Prime',       genre: 'mono'    },
  { id: 'spacemono',    nom: 'Space Mono',        famille: 'Space Mono',          genre: 'mono'    },
  { id: 'jetbrains',    nom: 'JetBrains Mono',    famille: 'JetBrains Mono',      genre: 'mono'    },
  { id: 'plexmono',     nom: 'IBM Plex Mono',     famille: 'IBM Plex Mono',       genre: 'mono'    },
  { id: 'robotomono',   nom: 'Roboto Mono',       famille: 'Roboto Mono',         genre: 'mono'    },
];

const GENRES = [
  { id: 'tous',    nom: 'Toutes'      },
  { id: 'sans',    nom: 'Sans serif'  },
  { id: 'serif',   nom: 'Serif'       },
  { id: 'script',  nom: 'Manuscrites' },
  { id: 'display', nom: 'Display'     },
  { id: 'retro',   nom: 'Rétro'       },
  { id: 'mono',    nom: 'Monospace'   },
];

/* --- Carga perezosa ------------------------------------------------------ */
const _chargees = new Map();   // famille -> Promise

function chargerPolice(famille) {
  if (_chargees.has(famille)) return _chargees.get(famille);

  const p = new Promise(resolve => {
    const lien = document.createElement('link');
    lien.rel = 'stylesheet';
    lien.href = 'https://fonts.googleapis.com/css2?family='
              + encodeURIComponent(famille).replace(/%20/g, '+')
              + ':wght@400;700&display=swap';
    lien.onload = lien.onerror = () => {
      // el <link> cargado no garantiza que el navegador tenga los glyphs:
      // document.fonts.load fuerza la descarga real del fichero
      const f = document.fonts
        ? document.fonts.load(`400 32px "${famille}"`).catch(() => {})
        : Promise.resolve();
      f.then(() => resolve(famille));
    };
    document.head.appendChild(lien);
  });

  _chargees.set(famille, p);
  return p;
}

function policePar(id) { return POLICES.find(p => p.id === id) || POLICES[0]; }
